// extracted by mini-css-extract-plugin
export default {"overlay":"gC-z","bodyOpen":"hC-z","content":"iC-z","header":"jC-z","close":"kC-z","closeNoHeading":"lC-z"};